export const slackAppConnectionErrorKey = "c8r-slack-app-connection-error";
export const slackAppConnectionIdKey = "c8r-slack-app-connection-id";
